module.exports = __webpack_public_path__ + "img/special_2.657f80ec.svg";